import { render, staticRenderFns } from "./StudentRegistrationForm.vue?vue&type=template&id=6d830027&scoped=true"
import script from "./StudentRegistrationForm.vue?vue&type=script&lang=js"
export * from "./StudentRegistrationForm.vue?vue&type=script&lang=js"
import style0 from "./StudentRegistrationForm.vue?vue&type=style&index=0&id=6d830027&prod&lang=css"
import style1 from "./StudentRegistrationForm.vue?vue&type=style&index=1&id=6d830027&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d830027",
  null
  
)

export default component.exports